import { useState, useEffect } from 'react';
import { safeJsonParse } from '@utility/helperFunction';

export const useActiveCards = (seat, sentItems, pendingItems) => {
  const [activeCardsByCheckItemId, setActiveCardsByCheckItemId] = useState({});

  useEffect(() => {
    try {
      const raw = window.sessionStorage.getItem('seat');
      if (!raw) {
        setActiveCardsByCheckItemId({});
        return;
      }
      const seatData = safeJsonParse(raw, {});
      const allItems = Array.isArray(seatData?.AllItems) ? seatData.AllItems : [];
      const cards = Array.isArray(seatData?.cards) ? seatData.cards : [];

      const validCardsByAllItemId = new Map();
      const invalidCardsByAllItemId = new Map();
      for (const c of cards) {
        const key = c?.checkOrderItemId;
        if (!key) continue;
        if (c?.status === 5 && c?.redactedCardNumber) {
          if (!validCardsByAllItemId.has(key)) validCardsByAllItemId.set(key, []);
          validCardsByAllItemId.get(key).push(c.redactedCardNumber);
        } else if (c?.status !== 5) {
          invalidCardsByAllItemId.set(key, true);
        }
      }
      const lookup = {};
      for (const ai of allItems) {
        if (!ai?.id || !ai?.checkItemId) continue;
        const validCards = validCardsByAllItemId.get(ai.id) || [];
        const hasInvalidCards = invalidCardsByAllItemId.has(ai.id) || false;
        if (validCards.length || hasInvalidCards) {
          lookup[ai.checkItemId] = { validCards, hasInvalidCards };
        }
      }
      setActiveCardsByCheckItemId(lookup);
    } catch {
      setActiveCardsByCheckItemId({});
    }
  }, [seat?.id, sentItems, pendingItems]);

  return activeCardsByCheckItemId;
};
